export default "__VITE_ASSET__BhqjgLDT__"